import set from "lodash.set";
import { createSelector } from "reselect";
import { PlaceType } from "../constants/PlaceType";
import cloneDeep from "lodash.clonedeep";

export const transformToRide = createSelector(
  values => values?.dateTime,
  values => values?.routePoints,
  values => values?.routePoints?.[0]?.types,
  values => values?.pet,
  values => values?.mask,
  values => values?.package,
  values => values?.routePoints?.[0]?.airport?.autocompleteTerminal?.terminal,
  values => values?.routePath?.routes[0].overview_polyline,
  values => values?.routePath?.routes?.[0].legs?.[0]?.distance?.value,
  values => values?.routePath?.routes?.[0].legs?.[0]?.duration?.value,
  values => values?.paymentType,
  values => values?.vehicleType,
  values => values?.account,
  (
    dateTime,
    routePoints,
    types,
    pet,
    mask,
    bag,
    puTerminal,
    overviewPolyline,
    distance,
    duration,
    paymentMethod,
    serviceType,
    account,
  ) => {

    const ride = {
      status: "NEW",
      puTime: 0,
      rideOptions: [],
    };

    const newRoutePoints = cloneDeep(routePoints);

    set(ride, "puTime", dateTime < new Date().getTime() ? 0 : dateTime);
    set(ride, "rideOptions", rideOptions(mask, pet, bag));
    set(ride, "route.routePoints", newRoutePoints);
    set(ride, "route.routePath.overviewPolyline", overviewPolyline);
    set(ride, "route.routePath.distance", distance);
    set(ride, "route.routePath.duration", duration * 1000);

    if (puTerminal) {
      set(ride, "route.routePoints[0].airport.terminal", puTerminal);
    }
    if (paymentMethod) {
      set(ride, "paymentMethod", paymentMethod);
    }
    if (serviceType) {
      set(ride, "serviceType", serviceType);
    }
    if (account) {
      set(ride, "account", account);
    }

    if (ride.route?.routePoints?.[0]?.placeType === PlaceType.AIRPORT && !ride?.route?.routePoints?.[0]?.airport?.iata) {
      ride.route.routePoints[0].placeType = PlaceType.LANDMARK;
    }
    return ride;
  },
);

export const placeType = (type) => {
  if (type === "street_address") {
    return PlaceType.ADDRESS;
  }
  if (type === "airport") {
    return PlaceType.AIRPORT;
  }
  return PlaceType.LANDMARK;
};

const rideOptions = (mask, pet, bag) => {
  const options = [];
  if (mask) {
    options.push("MASK");
  }
  if (pet) {
    options.push("PET");
  }
  if (bag) {
    options.push("PACKAGE");
  }
  return options;
};


export default transformToRide;


